import * as React from 'react';
import type { BlockedProductListEntry } from 'contracts/blocked-products';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Button as ButtonGs } from 'components/ui/ButtonGs';

type Props = {
  selectedProducts: BlockedProductListEntry[];
  totalProducts: number;
  onCreateRedirectedProducts?: (selectedProducts: BlockedProductListEntry[]) => void;
  onCreatePrioritizedProducts?: (selectedProducts: BlockedProductListEntry[]) => void;
}

export const DataTableDropdownMenu = ({
                                        selectedProducts,
                                        totalProducts,
                                        onCreatePrioritizedProducts,
                                        onCreateRedirectedProducts,
                                      }: Props) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger disabled={!selectedProducts.length}>
        <ButtonGs.Root size={'sm'} disabled={!selectedProducts.length}>
          Ações ({selectedProducts.length}/{totalProducts})
        </ButtonGs.Root>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'start'}>
        <DropdownMenuItem onClick={(event) => {
          onCreateRedirectedProducts?.(selectedProducts);
          event.stopPropagation();
        }}>
          Alterar SLOC
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(event) => {
          onCreatePrioritizedProducts?.(selectedProducts);
          event.stopPropagation();
        }}>
          Adicionar prioridade
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};